export class BaseGenericResponse<T> {
  object = 'baseGenericResponse';
  value: T;
}
